import { PayoutDetailsInfo } from "@modules/financesPayout/components/payoutDetailsInfo"
import { PayoutEnumApi } from "@modules/financesPayout/gateway/payoutApi"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { SidebarNavigatorParams } from "@modules/sidebar/sidebarTypes"

export const usePayoutSidebar = () => {
  const { sidebarNavigateTo } = useSidebar()

  const navigateToPayoutDetails = (payoutEnumApi: PayoutEnumApi, payoutId: string, args: SidebarNavigatorParams) => {
    sidebarNavigateTo({
      content: <PayoutDetailsInfo payoutEnumApi={payoutEnumApi} payoutId={payoutId} />,
      onHide: () => {
        return Promise.resolve(true)
      },
      ...args,
    })
  }

  return { navigateToPayoutDetails }
}
